import { useState } from "react";
import { Space } from "antd";
import { FileDoneOutlined } from "@ant-design/icons";
import WorkflowUploadCard from "./WorkflowUploadCard";
import ExtractedDataCard from "./ExtractedDataCard";
import { uploadImageToWorkflow } from "../../services/workflowUpload";
import { IExtractedData } from "../types/workflow.types";
import { getErrorMessage } from "../../utils/getErrorMessage";
import { toastError, toastSuccess } from "../../utils/toast";

const isWeightKey = (key: string) => key.toLowerCase().includes("weight");

const FinalWeightmentTab = () => {
  const [file, setFile] = useState<File | null>(null);
  const [uploading, setUploading] = useState(false);
  const [uploaded, setUploaded] = useState(false);
  const [extractedData, setExtractedData] = useState<IExtractedData | null>(null);

  const reset = () => {
    setFile(null);
    setUploaded(false);
    setExtractedData(null);
  };

  const handleUpload = async () => {
    if (!file) return;
    setUploading(true);
    try {
      const result = await uploadImageToWorkflow(file, "final_weightment", "");
      setExtractedData(result.extractedData);
      setUploaded(true);
      toastSuccess("Final weightment slip uploaded.");
    } catch (error) {
      toastError(
        getErrorMessage(error, "Could not upload the slip. Please try again.")
      );
    } finally {
      setUploading(false);
    }
  };

  return (
    <Space direction="vertical" size={16} style={{ width: "100%", maxWidth: 640 }}>
      <WorkflowUploadCard
        title="Final Weighing Slip"
        subtitle="Capture or upload the final slip"
        icon={<FileDoneOutlined />}
        file={file}
        uploading={uploading}
        uploaded={uploaded}
        onFileSelected={(selected) => {
          setFile(selected);
          setUploaded(false);
          setExtractedData(null);
        }}
        onRemove={reset}
        onUpload={handleUpload}
      />

      {extractedData && (
        <>
          <ExtractedDataCard
            data={extractedData}
            title="Weight Details"
            filterKeys={isWeightKey}
            sortOrder={["gross", "tare", "net"]}
            hideEmpty
          />
          <ExtractedDataCard
            data={extractedData}
            filterKeys={(key) => !isWeightKey(key)}
          />
        </>
      )}
    </Space>
  );
};

export default FinalWeightmentTab;
